module.exports = __webpack_public_path__ + "img/544.b6079ccc.jpg";